
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_temperature",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.temperature')
        },
        value() {
            return this.unitLmsgSensors.temperature?.text//this.$t('Not defined')
        },
        statusClass(){
            return 'danger'
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__temperature' : false
        }
    },
}
</script>

<style scoped>

</style>